import type { ConfluenceUpdatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/confluence-update-page-command';

import type { DocumentDynamicUiUpdateCommandProcessor } from '../../stream-processors/update-dynamic-ui-command-processor';
import type { DYNAMIC_UI_CREATE_KEY } from '../../types/command-manager';
import type { PageUpdateStrategy } from '../page-update-strategy';

type DynamicUiUpdatePayload = Extract<
	ConfluenceUpdatePageCommandProperties,
	{ key: typeof DYNAMIC_UI_CREATE_KEY }
>;

export class DynamicUiUpdateStrategy implements PageUpdateStrategy {
	constructor(private processor: DocumentDynamicUiUpdateCommandProcessor) {}

	async process(payload: ConfluenceUpdatePageCommandProperties): Promise<void> {
		const { data, isStreamComplete, traceId, singleInstrumentationId } =
			payload as DynamicUiUpdatePayload;
		await this.processor.streamChunk(data, isStreamComplete, traceId, singleInstrumentationId);
	}
}
